import { Card, CardContent } from '../ui/card';
import { AlertCircle, CheckCircle, AlertTriangle } from 'lucide-react';

export const ComplianceStatusCard = ({ status, percentage, className = '' }) => {
  const statusConfig = {
    compliant: {
      icon: CheckCircle,
      iconColor: 'text-green-600',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      title: 'Compliant',
      description: 'All AML/CTF requirements met'
    },
    action_required: {
      icon: AlertTriangle,
      iconColor: 'text-amber-600',
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-200',
      title: 'Action Required',
      description: 'Some clients need KYC completion'
    },
    at_risk: {
      icon: AlertCircle,
      iconColor: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      title: 'At Risk',
      description: 'Urgent: Many clients lack KYC'
    }
  };

  const config = statusConfig[status] || statusConfig.at_risk;
  const Icon = config.icon;

  return (
    <Card 
      className={`${config.borderColor} border-l-4 ${className}`}
      data-testid="compliance-status-card"
    >
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className={`w-12 h-12 ${config.bgColor} rounded-lg flex items-center justify-center flex-shrink-0`}>
            <Icon className={`w-6 h-6 ${config.iconColor}`} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-1" style={{fontFamily: 'Plus Jakarta Sans, sans-serif'}}>
              {config.title}
            </h3>
            <p className="text-sm text-muted-foreground mb-3">{config.description}</p>
            {percentage !== undefined && (
              <div className="space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">KYC Completion</span>
                  <span className="font-semibold text-foreground">{percentage.toFixed(1)}%</span>
                </div>
                <div className="w-full bg-muted rounded-full h-2">
                  <div 
                    className={`h-2 rounded-full transition-all duration-300 ${
                      status === 'compliant' ? 'bg-green-500' :
                      status === 'action_required' ? 'bg-amber-500' :
                      'bg-red-500'
                    }`}
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};